<template>
  <div class="c-me-command">
    <n-loader :loading="$var('load')" />
    <div>
      <n-card>
        <div class="memo">
          <table class="memo-table">
            <tr class="row header">
              <td></td>
              <td>КЛН</td>
              <td>Оценка смены/участка</td>
            </tr>
            <tr v-for="item in memoRows" class="row">
              <td>{{ item.position }}</td>
              <td>{{ item.kln }}</td>
              <td :class="{'none': item.grades === 'n\\a'}">{{ item.grades }}</td>
            </tr>
          </table>
        </div>
        <div class="buttons">
          <n-select :data="branches" item-value="id" title="Выберите филиал" v-bind="$form.input('branch', 'select')" />
        </div>
        <div class="date-input">
          <div class="title">
            Выберите даты
          </div>
          <div class="filter">
            <n-input title="От" type="date" v-bind="$form.input('from')"></n-input>
            <n-input title="До" type="date" v-bind="$form.input('to')"></n-input>
          </div>
        </div>
        <div v-if="users.length > 0" class="users-list">
          <div class="title">Заполните смены пользователей: </div>
          <div v-for="item in users" class="user-row">
            <div class="fullName">{{ item.fullName }}</div>
            <div class="input-place">
              <n-input :value="usersData[item.id]" @input="(v) => setField(item.id, v)" />
            </div>
          </div>
        </div>
        <div v-if="isBtnDisabled" class="button-place">
          <n-button @click="loadDoc">Скачать документ МЕ КОМАНДЫ</n-button>
        </div>
      </n-card>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CMeCommand',
  data: () => ({
    data: [],
    branches: [],
    users: [],
    usersData: {},
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
    memoRows: [
      { position: 'Директор', kln: '', grades: 5, },
      { position: '1 зам.', kln: '', grades: 5, },
      { position: 'зам.', kln: '10', grades: 5, },
      { position: 'Менеджер смены', kln: '1 КЛН в смену', grades: 'n\\a', },
      { position: 'Менеджер участка', kln: '1 КЛН в смену', grades: 'n\\a', },
    ],
  }),
  computed: {
    branch() {
      return this.$form.get()
    },
    isBtnDisabled() {
      let disable = true

      if (Object.keys(this.usersData).length === 0) {
        disable = false
      }

      $n.each(this.usersData, (e) => {
        if (!e) {
          disable = false
        }
      })

      return disable
    },
    isTop() {
      let isTop = false
      $n.filter($app.auth.user().accesses, (e) => {
        if ([ 'superAdmin', ].includes(e.title)) {
          isTop = true
        }
      })
      return isTop
    },
  },
  watch: {
    branch() {
      this.loadUsersFill()
    },
  },
  created() {
    this.$form.init({
      branch: {},
      from: $app.date.format(new Date().setDate(1), 'filterDate'),
      to: $app.date.format(new Date(new Date().setMonth(new Date().getMonth() + 1)).setDate(0), 'filterDate'),
    })
    this.getBranches()
  },
  methods: {
    setField(id, value) {
      this.usersData = {
        ...this.usersData,
        [id]: value,
      }
    },
    loadUsersFill() {
      this.$var('load', true)
      $api.meCommand.getUsers({
        branchId: this.$form.get('branch.id'),
      }).then((response) => {
        this.users = response.data.content
        let obj = {}
        $n.each(this.users, (e) => {
          obj = {
            ...obj,
            [e.id]: '',
          }
        })
        this.usersData = obj
      }).finally(() => {
        this.$var('load', false)
      })
    },
    getBranches() {
      this.$var('load', true)
      let api = $api.branches.get().all()
      if ($app.auth.user().branchId && !this.isTop) {
        api = api.filter({ id: $app.auth.user().branchId, })
      }
      api.then((response) => {
        this.branches = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    loadDoc() {
      this.$var('load', true)
      const data = {
        branchId: this.$form.get('branch.id'),
        usersIdsPlan: this.usersData,
        from: this.$form.get('from'),
        to: this.$form.get('to'),
      }
      $api.meCommand.makeDoc(data).then((response) => {
        const res = response.data.content
        const a = document.createElement('a')
        a.href = res.src
        a.click()
        a.remove()
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.c-me-command {
  overflow: auto;
  position: relative;

  .filter {
    display: flex;
    align-items: center;
    max-width: 300px;
    .n-input {
      margin-right: 15px;
    }
  }


  .memo-table {
    margin-bottom: 15px;
    td {
      padding: 5px;
      border: 1px solid #000000;
    }
    .row {

      &.header {
        td {
          background-color: #ffff9d;
        }
      }


      td {
        text-align: center;
        vertical-align: center;


        &.none {
          background-color: #c0c0c0;
        }
        &:nth-child(1) {
          width: 250px;
        }
        &:nth-child(2) {
          width: 170px;
        }
        &:nth-child(3) {
          width: 140px;
        }
      }
    }

  }


  .users-list {
    margin-top: 20px;
  }
  .button-place {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: right;
  }
  .user-row {
    display: flex;
    align-items: center;
    max-width: 400px;
    justify-content: space-between;
    margin-bottom: 10px;
    .input-place {
      max-width: 60px;
    }
    .fullName {
      margin-right: 15px;
    }
  }
  .n-card {
    min-height: 500px;
  }
  .date-input {
  }
  .items {
    display: flex;
    align-items: center;
    padding: 10px;
  }
  .month-selector {
    display: inline-block;
    background-color: #c5c4c4;
    margin-top: 20px;
    border-radius: 12px;
    color: #ffffff;
    .dec, .inc {
      cursor: pointer;
    }
    .date {
      margin: 0 20px;
    }
  }
}
</style>
